module.exports = __webpack_public_path__ + "img/collectible-card-lp-back.236c7345.svg";